import { configureStore } from '@reduxjs/toolkit';
import beacon4FiltersReducer                        from '../reducers/Beacon4FiltersReducer';
import beacon4PerformanceNetworkOverviewKpiDataReducer from '../reducers/Beacon4PerformanceNetworkOverviewKpiDataReducer';
import beacon4PerformanceNetworkOverviewAdminReducer   from '../reducers/Beacon4PerformanceNetworkOverviewAdminReducer';

const Beacon4Store = configureStore({
	reducer: {
		beacon4Filters:                        beacon4FiltersReducer,
		beacon4PerformanceNetworkOverviewKpiData: beacon4PerformanceNetworkOverviewKpiDataReducer,
		beacon4PerformanceNetworkOverviewAdmin:   beacon4PerformanceNetworkOverviewAdminReducer,
	},
});

export default Beacon4Store;
